import _kebabCase from 'lodash/kebabCase';
import { ITrackingStatus } from '@packlink/packlink-sdk';
import { IconNames } from '@shipengine/giger-theme';

function getRootTrackingStatus(status) {
  // Important, include first the most restrictive queries
  const rootStatus = [ITrackingStatus.IN_TRANSIT_INCIDENT, ITrackingStatus.OUT_FOR_DELIVERY_INCIDENT, ITrackingStatus.READY_FOR_COLLECTION_INCIDENT, ITrackingStatus.IN_TRANSIT, ITrackingStatus.OUT_FOR_DELIVERY, ITrackingStatus.READY_FOR_COLLECTION, ITrackingStatus.RETURNED_TO_SENDER, ITrackingStatus.DELIVERED, ITrackingStatus.EXCEPTION].find(s => status.includes(s));
  return rootStatus;
}
function getTrackingStatusIconName(status) {
  const rootStatus = getRootTrackingStatus(status);
  switch (rootStatus) {
    case ITrackingStatus.DELIVERED:
      return IconNames.CARDBOARD_BOX_CHECK;
    case ITrackingStatus.IN_TRANSIT:
      return IconNames.TRUCK;
    case ITrackingStatus.OUT_FOR_DELIVERY:
    case ITrackingStatus.READY_FOR_COLLECTION:
      return IconNames.TROLLEY;
    case ITrackingStatus.EXCEPTION:
    case ITrackingStatus.IN_TRANSIT_INCIDENT:
    case ITrackingStatus.OUT_FOR_DELIVERY_INCIDENT:
    case ITrackingStatus.READY_FOR_COLLECTION_INCIDENT:
      return IconNames.ALERT;
    case ITrackingStatus.RETURNED_TO_SENDER:
      return IconNames.HAND_BOX;
    default:
      return IconNames.INFO;
  }
}
function getTrackingStatusLabelKey(status) {
  const rootStatus = getRootTrackingStatus(status);
  const parsedRootStatus = rootStatus ? _kebabCase(rootStatus) : 'unknown';
  return `tracking-details.status-label.${parsedRootStatus}`;
}
function getTrackingStatusDescriptionKey(status) {
  return `tracking-details.status-description.${_kebabCase(status)}`;
}
function shouldRenderTrackingStatusRawDescription(status) {
  return [ITrackingStatus.IN_TRANSIT_07, ITrackingStatus.IN_TRANSIT_100].includes(status);
}
function isIncidentTrackingStatus(status) {
  const rootStatus = getRootTrackingStatus(status);
  if (!rootStatus) {
    return false;
  }
  return [ITrackingStatus.IN_TRANSIT_INCIDENT, ITrackingStatus.OUT_FOR_DELIVERY_INCIDENT, ITrackingStatus.READY_FOR_COLLECTION_INCIDENT, ITrackingStatus.EXCEPTION].includes(rootStatus);
}

export { getRootTrackingStatus, getTrackingStatusDescriptionKey, getTrackingStatusIconName, getTrackingStatusLabelKey, isIncidentTrackingStatus, shouldRenderTrackingStatusRawDescription };
//# sourceMappingURL=TrackingStatus.js.map
